import React, { useEffect, useState } from 'react'
import InputField from 'components/InputField'
import Select from "react-select"
import Button from 'react-bootstrap/esm/Button'
import { useSelector } from "react-redux"
import moment from 'moment'
import { getNutritionistDetails, saveNutritionDietPlan } from 'core/services/api/patientClinicalService'
import { addNewCancerTemplate, getDataCancerTemplate, getListCancerTemplate, getManageStaffDetailsById, uploadSpecificFile } from 'core/services/api'
import SurveyComponent from 'pages/RMO/components/cancerTemplate/Template'
import Toast from 'components/Toast'
import DietPlanPrint from './DietPlanPrint'

export default function AddDietPlan(props: any) {
  const { appointmentDetails, recordDetails, patientInfo, isReadOnly, componentRef, vitalsData, smartSummaryData } = props
  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const patientId = appointmentDetails?.patientId
  const recordId = recordDetails?.id
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const mealPlanItem: any = {
    meal: "",
    time: "",
    menu: ""
  }
  const balancedDiet = {
    calories: "1400 kcal",
    proteins: "50 gm",
    fat: "15 ml",
    ffd: "",
    dietPlan: "Balanced Diet",
    mealPlan: [
      {
        meal: "Breakfast",
        time: "8 am",
        menu: `One cup vegetable upma/Poha \nOR One cup oats porridge \nOR Two khakhra /Chapati With One cup milk/One egg preparation \nOR Two medium idlis/Dosa/one uttapam with One cup sambar`
      },
      {
        meal: "Mid morning",
        time: "10 am",
        menu: "One fruit (Stewed/Freshly cut/Thick skinned) + 3-4 pcs almonds and walnuts"
      },
      {
        meal: "Lunch",
        time: "12-1pm",
        menu: `One cup cooked vegetables \nOne cup rice/ Two Phulkas/Two small jowar or bajra roti \nOne cup Dal/Pulses/Soya/Chicken/Fish (50 gm- Non fried) \nOne cup curd/ 50gm Paneer`
      },
      {
        meal: "Snacks",
        time: "4 pm",
        menu: `One cup tea  With One cup roasted kurmura/makhana/Homemade Poha chiwda \nOR Two khakhra \nOR One cup roasted makhana`
      },
      {
        meal: "Late Evening",
        time: "6-7pm",
        menu: "One bowl dal vegetable soup/One glass buttermilk"
      },
      {
        meal: "Dinner",
        time: "8.30-9.30 pm",
        menu: `Same as lunch  \nOR  One paneer stuffed paratha with One cup curd  \nOR One bowl dal vegetable khichdi with One cup curd `
      },
      {
        meal: "Bedtime",
        time: "10.30-11pm",
        menu: "One cup cow’s milk"
      }
    ]
  }

  const highProteinDiet = {
    calories: "1600 kcal",
    proteins: "60 gm",
    fat: "15 ml",
    ffd: "",
    dietPlan: "High Protein Diet",
    mealPlan: [
      {
        meal: "Early Morning",
        time: "8 am",
        menu: "One glass cow’s milk /One egg preparation\n+ Soaked (3-4 almonds and walnuts + 2 Anjeer/fig +  3-4  Black Raisins + 2-3 Dates)"
      },
      {
        meal: "Breakfast",
        time: "9:30 am",
        menu: "One Cup Tea ( Cow’s Milk )\nwith One cup vegetable Poha\nOR One cup vegetable  Upma ( oats/ Daliya/rawa/Sevai)\nOR Two medium idli /dosa/One Uttapam with cooked tomato or corriander chutney\nOR  One medium Mix Veg Paratha\nOR  Two medium Thepla "
      },
      {
        meal: "Mid Morning",
        time: "11:30am",
        menu: "1 Medium Fruit\n(Boiled OR washed with hot water & cut peeled OR Thick skin fruit) "
      },
      {
        meal: "Lunch",
        time: "1:30 pm",
        menu: "Two Phulka ( without Oil) OR One cup rice\n+ One cup vegetable\n+ One cup thick Dal/Pulses/ sprouts/Soya\nOR 2 Medium pcs Chicken/fish/1 egg Preparation (Not fried)\nOR Paneer preparation (50gm/3-4 pcs)"
      },
      {
        meal: "Afternoon",
        time: "2:00 pm",
        menu: "One cup Curd OR One Glass Buttermilk\n(Use amchur powder/Roasted Jeera powder instead of salt/sugar/chaat masala) "
      },
      {
        meal: "Evening Snacks",
        time: "5:00 pm",
        menu: "One cup Tea ( Cow’s Milk )\nwith One Handful Roasted Chana/ Boiled Sprouts\nOR Two vegetable Besan or moong dal Chillas\nOR 3-4 pcs Yellow Dhokla / 3-4 pcs Khandvi"
      },
      {
        meal: "Late evening",
        time: "7:00 pm",
        menu: "1 bowl Mix Vegetable dal Soup\n(Add 1 tablespoon Moong dal while cooking vegetable) "
      },
      {
        meal: "Dinner",
        time: "8:30 pm",
        menu: "Same as lunch with one cup Curd OR One Glass Buttermilk\nOR\nOne Bowl mix vegetable dal khichdi (Rice/Daliya)+ 1 bowl kadhi + one cup Curd/ One Glass Buttermilk\nOR\nOne medium Bajra/Ragi roti with 1 Katori vegetable with 1 Katori Dal + one cup Curd/ One Glass Buttermilk"
      },
      {
        meal: "Bed Time",
        time: "10:30 pm",
        menu: "One glass cow’s Milk "
      }
    ]
  }

  const highProteinDiet2 = {
    calories: "1800 kcal",
    proteins: "70 gm",
    fat: "15 ml",
    ffd: "",
    dietPlan: "High Protein Diet 2",
    mealPlan: [
      {
        meal: "Early Morning",
        time: "8 am",
        menu: "One glass cow’s milk With Soaked (3-4 almonds and walnuts + 2 Anjeer +  3-4  Black Raisins + 2-3 Dates)"
      },
      {
        meal: "Breakfast",
        time: "9:30 am",
        menu: "One Cup Tea ( Cow’s Milk ) with One cup vegetable Poha\nOR One cup vegetable  Upma ( oats/ Daliya/rawa/Sevai)\nOR Two medium idli / 1 dosa/1 Uttapam with Cooked tomato or Corriander chutney\nOR  One medium Mix Veg Paratha\nOR  One medium Thepla +  One egg preparation/One cup boiled moong/sprouts"
      },
      {
        meal: "Mid Morning",
        time: "11:30am",
        menu: "One Medium Fruit\n(Boiled OR washed with hot water & cut peeled OR Thick skin fruit)"
      },
      {
        meal: "Lunch",
        time: "1:30 pm",
        menu: "Two Phulka ( without Oil) + One cup rice + One cup vegetable + One cup thick Dal/Pulses/ sprouts/Soya\nOR 2 Medium pcs Chicken/fish/1 egg Preparation (Not fried)\nOR Paneer preparation (50gm/3-4 pcs)"
      },
      {
        meal: "Afternoon",
        time: "2:00 pm",
        menu: "One cup curd OR One Glass Buttermilk (Use amchur powder/Roasted Jeera powder instead of salt/sugar/chaat masala)"
      },
      {
        meal: "Evening Snacks",
        time: "5:00 pm",
        menu: "One cup Tea ( Cow’s Milk ) with One Handful Roasted Chana/ Boiled Sprouts\nOR Two vegetable Besan or moong dal Chillas\nOR 3-4 pcs Yellow Dhokla / 3-4 pcs Khandvi"
      },
      {
        meal: "Late evening",
        time: "7:00 pm",
        menu: "One bowl Mix Vegetable Soup (Add 1 tablespoon Moong dal while cooking vegetable)"
      },
      {
        meal: "Dinner",
        time: "8:30 pm",
        menu: "Same as lunch + One cup curd One Bowl mix vegetable dal khichdi (Rice/Daliya)+ 1 bowl kadhi + one cup Curd/ One Glass Buttermilk\nOR One medium Bajra/Ragi roti with One cup vegetable with One cup Dal + one cup Curd/ One Glass Buttermilk"
      },
      {
        meal: "Bed Time",
        time: "10:30 pm",
        menu: "One glass cow’s Milk "
      }
    ]
  }

  const renalDiet = {
    calories: "1400 kcal",
    proteins: "50 gm",
    fat: "15 ml",
    ffd: "600 ml",
    dietPlan: "Renal Diet",
    mealPlan: [
      {
        meal: "Breakfast",
        time: "8 am",
        menu: "One cup vegetable upma/Poha\nOR Two khakhra /Chapati With One cup cow’s milk(150ml)/One egg preparation\nOR  Two medium idlis/Dosa/One uttapam with One cup sambar "
      },
      {
        meal: "Mid morning",
        time: "10 am",
        menu: "100-150 fruit\n(Stewed/Freshly cut-Guava, Pear, Papaya, Pineapple, Apple)"
      },
      {
        meal: "Lunch",
        time: "12-1pm",
        menu: "One cup cooked vegetables\nOne cup rice/ Two Phulkas\nOne cup Dal(100ml)/ Chicken/Fish (2medium pcs- Non fried, Once a week)\nOne big cup hungcurd/ 60gm Paneer"
      },
      {
        meal: "Snacks",
        time: "4 pm",
        menu: "One cup tea (100ml)\nWith One cup roasted kurmura/roasted Poha chiwda/Makhana/2 khakhra"
      },
      {
        meal: "Dinner",
        time: "8.30-9.30 pm",
        menu: "One cup cooked vegetables\nOne cup rice/ Two Phulkas\nOne cup Dal(100ml)/ Chicken/Fish (50 gm- Non fried, Once a week)\nOne big cup hungcurd/ 60gm Paneer"
      },
      {
        meal: "Bedtime",
        time: "10.30-11pm",
        menu: "One cup cow’s milk (150ml)"
      }
    ]
  }

  const rtFeed = {
    calories: "848 kcal",
    proteins: "40.9 gm",
    fat: "18.5 ml",
    ffd: "",
    dietPlan: "RT Feed",
    mealPlan: [
      {
        meal: "6 am",
        time: "200 ml",
        menu: `Water + `
      },
      {
        meal: "8 am",
        time: "200 ml",
        menu: "Milk + "
      },
      {
        meal: "10 am",
        time: "200 ml",
        menu: "150 grams stewed apple pureed"
      },
      {
        meal: "12 pm",
        time: "200 ml",
        menu: "Chapati 30 grams + dal 30 grams Pureed "
      },
      {
        meal: "2 pm",
        time: "200 ml",
        menu: "Dal 100 grams pureed "
      },
      {
        meal: "4 pm",
        time: "200 ml",
        menu: "Dal pani/Moong pani + "
      },
      {
        meal: "6 pm",
        time: "200 ml",
        menu: "Clear mix. Veg soup/Rice Kanji+"
      },
      {
        meal: "8 pm",
        time: "200 ml",
        menu: "Rice 40 grams + dal 60 grams pureed "
      },
      {
        meal: "10 pm",
        time: "200 ml",
        menu: "Milk + "
      }
    ]
  }

  const fullLiquidDiet = {
    calories: "700 kcal",
    proteins: "25 gm",
    fat: "",
    ffd: "",
    dietPlan: "Full Liquid Diet",
    mealPlan: [
      {
        meal: "6 am",
        time: "200 ml",
        menu: "Barley water"
      },
      {
        meal: "8 am",
        time: "200 ml",
        menu: "Milk/Soyamilk"
      },
      {
        meal: "10 am",
        time: "200 ml",
        menu: "Fruit milkshake/smoothie/Fruit juice"
      },
      {
        meal: "12 pm",
        time: "200 ml",
        menu: "Rice kanji"
      },
      {
        meal: "2 pm",
        time: "200 ml",
        menu: "Buttermilk"
      },
      {
        meal: "4 pm",
        time: "200 ml",
        menu: "Clear mix veg soup "
      },
      {
        meal: "6 pm",
        time: "200 ml",
        menu: "Moong pani "
      },
      {
        meal: "8 pm",
        time: "200 ml",
        menu: "Dal soup "
      },
      {
        meal: "10 pm",
        time: "200 ml",
        menu: "Milk/Soyamilk"
      }
    ]
  }

  const [dietPlanOptions, setDietPlanOptions] = useState<any>([])
  const [selectedDietPlan, setSelectedDietPlan] = useState<any>("")
  const [dietPlanDetails, setDietPlanDetails] = useState<any>({
    medicalComorbidities: "",
    dietModifications: "",
    dietAdviced: "",
    dietPlanData: {
      calories: "",
      proteins: "",
      fat: "",
      ffd: "",
      dietPlan: "",
      mealPlan: [
        {
          meal: "",
          time: "",
          menu: ""
        }
      ]
    },
    nutritionalRemarks: "",
    dieticianName: "",
    dateTime: "",
    dieticianEmpNo: "",
    dieticianSignature: ""
  })
  const [templates, setTemplates] = useState<any>([])
  const [updateTemplateList, setupdateTemplateList] = useState<boolean>(false)
  const [newDietPlanName, setNewDietPlanName] = useState<any>("")
  const [signatureJson, setSignatureJson] = useState<any>({
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "dieticianSignature",
            "title": "Dietician Signature",
            "hideNumber": true,
          }
        ]
      }
    ],
    showNavigationButtons: "none"
  })
  const [signatureData, setSignatureData] = useState<any>({})
  const [staffDetails, setStaffDetails] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, setDisplayToast] = useState<any>(false)

  useEffect(() => {
    const type = "DIETPLAN"
    const centerId = userDetail?.currentCenter?.centerId
    getListCancerTemplate(type, centerId)
      .then((res: any) => {
        setTemplates(res)
        const templateOptions: any = res?.map((vals: any) => {
          return {
            label: vals?.subType,
            value: vals?.id,
          }
        })
        setDietPlanOptions(templateOptions)
      })
      .catch((err: any) => {
        console.log(err)
      })
  }, [updateTemplateList])

  useEffect(() => {
    getStaffDetails()
  }, [])

  useEffect(() => {
    getDietPlanDetails()
  }, [staffDetails])

  useEffect(() => {
    if (isReadOnly) {
      const tempJson = { ...signatureJson }
      tempJson["pages"][0]["readOnly"] = true
      setSignatureJson(tempJson)
    }
  }, [isReadOnly])

  useEffect(() => {
    if (selectedDietPlan) {
      getDataCancerTemplate("CHEMO", selectedDietPlan)
        .then((res: any) => {
          const { templateName, dietPlanData } = res
          const temp = { ...dietPlanDetails }
          temp["dietPlanData"] = dietPlanData
          setDietPlanDetails(temp)
        })
        .catch((err: any) => {
          setDisplayToast({
            message: `Failed to laod the diet plan, please try again later.`,
            type: "error",
          })
        })
    }
  }, [selectedDietPlan])

  const getDietPlanDetails = () => {
    if (recordId && (staffDetails !== undefined)) {
      // setIsLoading(true)
      getNutritionistDetails(recordId)
        .then((data: any) => {
          const temp: any = { ...dietPlanDetails, ...data?.dietPlan }
          let tempDate = moment().format("YYYY-MM-DDTHH:mm")
          if (!temp["dieticianName"]) {
            temp["dieticianName"] = staffDetails?.name
          }
          if (!temp["dateTime"]) {
            temp["dateTime"] = tempDate
          }
          if (!temp["dieticianEmpNo"]) {
            temp["dieticianEmpNo"] = staffDetails?.mocConsultantId
          }
          if (!temp["dieticianSignature"]) {
            temp["dieticianSignature"] = staffDetails?.signaturePicUrl
          }
          setDietPlanDetails(temp)
          if (temp?.dieticianSignature) {
            const tempData: any = { ...signatureData }
            tempData["dieticianSignature"] = temp?.dieticianSignature
            setSignatureData(tempData)
          } else if (!temp?.dieticianSignature) {
            const tempData: any = { ...signatureData }
            tempData["dieticianSignature"] = staffDetails?.signaturePicUrl
            setSignatureData(tempData)
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          const temp: any = { ...dietPlanDetails }
          let tempDate = moment().format("YYYY-MM-DDTHH:mm")
          if (!temp["dieticianName"]) {
            temp["dieticianName"] = staffDetails?.name
          }
          if (!temp["dateTime"]) {
            temp["dateTime"] = tempDate
          }
          if (!temp["dieticianEmpNo"]) {
            temp["dieticianEmpNo"] = staffDetails?.mocConsultantId
          }
          if (!temp["dieticianSignature"]) {
            temp["dieticianSignature"] = staffDetails?.signaturePicUrl
          }
          setSignatureData({
            dieticianSignature: temp?.dieticianSignature
          })
          setDietPlanDetails(temp)
          setIsLoading(false)
        })
    }
  }

  const getStaffDetails = () => {
    if (userDetail?.id) {
      getManageStaffDetailsById(userDetail?.id)
        .then((res: any) => {
          setStaffDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  const handleNutritionistDietCompletion = async () => {
    // setIsLoading(true)
    let dataObj = { ...dietPlanDetails }
    if (signatureData?.dieticianSignature) {
      if (!signatureData?.dieticianSignature?.includes("http")) {
        try {
          const response = await fetch(signatureData?.dieticianSignature);
          const data = await response.blob()
          const metadata = {
            type: "image/png"
          };
          const file = new File([data], `dietician_signature.png`, metadata);
          const formData = new FormData()
          formData.append('files', file)

          const uploadedFiles = await uploadSpecificFile(formData, true);
          dataObj["dieticianSignature"] = uploadedFiles[0]
        } catch (err: any) {
          dataObj["dieticianSignature"] = ""
          const errCode = err?.response?.data?.code
          if (errCode === 'MaxUploadSizeExceededException') {
            setDisplayToast({
              message: errCode,
              type: "error",
            })
          }
          console.error("Error in uploading file", err)
        }
      } else {
        dataObj["dieticianSignature"] = signatureData?.dieticianSignature
      }
    } else {
      dataObj["dieticianSignature"] = ""
    }
    setDietPlanDetails(dataObj)
    saveNutritionDietPlan(
      dataObj,
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((res: any) => {
        setIsLoading(false)
        setDisplayToast({
          message: "Saved Successfully",
          type: "success",
        })
        setDietPlanDetails(res?.dietPlan)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
        setDisplayToast({
          message: `Something went wrong, please try again later.`,
          type: "error",
        })
      })
  }

  function saveDietPlanDetails() {
    if (newDietPlanName) {
      const temp = { ...dietPlanDetails }
      temp.dietPlanData.dietPlan = newDietPlanName
      const templateData = {
        type: "DIETPLAN",
        centers: [userDetail?.currentCenter?.centerId],
        subType: newDietPlanName,
        data: [
          {
            json: {
              templateName: newDietPlanName,
              dietPlanData: temp?.dietPlanData
            }
          }
        ],
      }
      addNewCancerTemplate(templateData)
        .then((res: any) => {
          setupdateTemplateList((current) => !current)
          setSelectedDietPlan(res?.id)
          setDisplayToast({ message: "New Template added Successfully", type: "success" })
          setNewDietPlanName("")
        })
        .catch((err: any) => {
          console.log(err)
          setDisplayToast({ message: "Unable to add new Template", type: "error" })
        })
    } else {
      setDisplayToast({ message: "Enter the diet plan name", type: "error" })
    }
  }

  const updateSurveyData = (data: any, surey: any) => {
    setSignatureData(data)
  }

  return (
    <div className="consultant-notes-wrapper">
      {
        isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : displayToast ? (
          <Toast
            textMessage={displayToast?.message}
            onCloseText={"Close"}
            onClose={() => {
              setDisplayToast(false)
            }}
            type={displayToast?.type}
          ></Toast>
        ) : null
      }
      <div className="advice mt-4">
        <div className="heading">Medical Comorbidities :</div>
        <div className='textarea'>
          <textarea
            value={dietPlanDetails?.medicalComorbidities}
            disabled={isReadOnly}
            onChange={(e) => {
              const temp: any = { ...dietPlanDetails }
              temp["medicalComorbidities"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            className={`${isReadOnly ? "disabled" : ""}`}
          />
        </div>
      </div>
      <div className="advice mt-4">
        <div className="heading">Diet Modifications :</div>
        <div className="textarea">
          <textarea
            value={dietPlanDetails?.dietModifications}
            disabled={isReadOnly}
            onChange={(e) => {
              const temp: any = { ...dietPlanDetails }
              temp["dietModifications"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            className={`${isReadOnly ? "disabled" : ""}`}
          />
        </div>
      </div>
      <div className="advice mt-4">
        <div className="heading">Diet Advised :</div>
        <div className="textarea">
          <textarea
            value={dietPlanDetails?.dietAdviced}
            disabled={isReadOnly}
            onChange={(e) => {
              const temp: any = { ...dietPlanDetails }
              temp["dietAdviced"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            className={`${isReadOnly ? "disabled" : ""}`}
          />
        </div>
      </div>
      <div className="diet-plan-section mt-4">
        <div className="referred-to-field mt-4">
          <div className="col-md-3">
            <label htmlFor="">Load Diet Plan</label>
            <Select
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={dietPlanOptions}
              onChange={(option: any) => {
                setSelectedDietPlan(option?.value)
              }}
              placeholder="Select Diet Plan"
              value={
                dietPlanOptions?.filter((each: any) => each?.label === dietPlanDetails?.dietPlanData?.dietPlan
                )?.length > 0 ?
                  dietPlanOptions?.filter((each: any) => each?.label === dietPlanDetails?.dietPlanData?.dietPlan
                  )
                  :
                  {
                    label: selectedDietPlan,
                    value: selectedDietPlan
                  }
              }
              isDisabled={isReadOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="">New Diet Plan Name</label>
            <InputField
              placeholder="Name"
              handleChange={(e: any) => setNewDietPlanName(e?.target?.value)}
              value={newDietPlanName}
              readOnly={isReadOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor=""></label>
            <div className='mt-2'>
              <Button
                className="diet-plan-button"
                variant="primary"
                disabled={isReadOnly}
                onClick={() => {
                  saveDietPlanDetails()
                }}
              >
                Save as new diet plan
              </Button>
            </div>
          </div>
        </div>
        {
          dietPlanDetails && Object.keys(dietPlanDetails)?.length > 0 ? (
            <div className="test-required mt-4">
              <div className="referred-to-field mt-4 mb-4">
                <div className="col-md-2">
                  <label htmlFor="">Diet Plan</label>
                  <InputField
                    placeholder="Diet Plan"
                    handleChange={(e: any) => {
                      const temp: any = { ...dietPlanDetails }
                      temp["dietPlanData"]["dietPlan"] = e?.target?.value
                      setDietPlanDetails(temp)
                    }}
                    value={dietPlanDetails?.dietPlanData?.dietPlan}
                    readOnly={true}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="">Calories</label>
                  <InputField
                    placeholder="Calories"
                    handleChange={(e: any) => {
                      const temp: any = { ...dietPlanDetails }
                      temp["dietPlanData"]["calories"] = e?.target?.value
                      setDietPlanDetails(temp)
                    }}
                    value={dietPlanDetails?.dietPlanData?.calories}
                    readOnly={isReadOnly}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="">Proteins</label>
                  <InputField
                    placeholder="Proteins"
                    handleChange={(e: any) => {
                      const temp: any = { ...dietPlanDetails }
                      temp["dietPlanData"]["proteins"] = e?.target?.value
                      setDietPlanDetails(temp)
                    }}
                    value={dietPlanDetails?.dietPlanData?.proteins}
                    readOnly={isReadOnly}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="">Fat</label>
                  <InputField
                    placeholder="Fat"
                    handleChange={(e: any) => {
                      const temp: any = { ...dietPlanDetails }
                      temp["dietPlanData"]["fat"] = e?.target?.value
                      setDietPlanDetails(temp)
                    }}
                    value={dietPlanDetails?.dietPlanData?.fat}
                    readOnly={isReadOnly}
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="">FFD</label>
                  <InputField
                    placeholder="FFD"
                    handleChange={(e: any) => {
                      const temp: any = { ...dietPlanDetails }
                      temp["dietPlanData"]["ffd"] = e?.target?.value
                      setDietPlanDetails(temp)
                    }}
                    value={dietPlanDetails?.dietPlanData?.ffd}
                    readOnly={isReadOnly}
                  />
                </div>
              </div>
              <div className="custom-table">
                <table>
                  <thead>
                    <tr>
                      <th>Meal</th>
                      <th>Time</th>
                      <th>Menu</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {dietPlanDetails?.dietPlanData?.mealPlan?.map((e: any, index: any) => {
                      return (
                        <tr>
                          <td className="col-md-3">
                            <InputField
                              handleChange={(e: any) => {
                                const temp: any = { ...dietPlanDetails }
                                const values: any = [...dietPlanDetails?.dietPlanData?.mealPlan]
                                values[index]["meal"] = e?.target?.value
                                setDietPlanDetails(temp)
                              }}
                              value={e?.meal}
                              readOnly={isReadOnly}
                            />
                          </td>
                          <td className="col-md-2">
                            <InputField
                              handleChange={(e: any) => {
                                const temp: any = { ...dietPlanDetails }
                                const values: any = [...dietPlanDetails?.dietPlanData?.mealPlan]
                                values[index]["time"] = e?.target?.value
                                setDietPlanDetails(temp)
                              }}
                              value={e?.time}
                              readOnly={isReadOnly}
                            />
                          </td>
                          <td>
                            <textarea
                              value={e?.menu}
                              disabled={isReadOnly}
                              onChange={(e) => {
                                const temp: any = { ...dietPlanDetails }
                                const values: any = [...dietPlanDetails?.dietPlanData?.mealPlan]
                                values[index]["menu"] = e?.target?.value
                                setDietPlanDetails(temp)
                              }}
                              className={isReadOnly ? "disabled" : ""}
                            />
                          </td>
                          <td>
                            {
                              !isReadOnly && (
                                <div
                                  className="delete-icon"
                                  onClick={() => {
                                    if (dietPlanDetails?.dietPlanData?.mealPlan.length > 1) {
                                      const temp: any = { ...dietPlanDetails }
                                      const values = [...dietPlanDetails?.dietPlanData?.mealPlan]
                                      values.splice(index, 1)
                                      temp["dietPlanData"]["mealPlan"] = values
                                      setDietPlanDetails(temp)
                                    }
                                  }}
                                >
                                  <img
                                    src="../../assets/images/delete-icon.svg"
                                    alt=""
                                  />
                                </div>
                              )
                            }
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                {
                  <div className="comorbidities add-new mr-2">
                    {
                      !isReadOnly && (
                        <div
                          className="add-new-button"
                          onClick={() => {
                            const temp: any = { ...dietPlanDetails }
                            const values = [...dietPlanDetails?.dietPlanData?.mealPlan]
                            values.push(mealPlanItem)
                            temp["dietPlanData"]["mealPlan"] = values
                            setDietPlanDetails(temp)
                          }}
                        >
                          Add New
                        </div>
                      )
                    }
                  </div>
                }
              </div>
            </div>
          ) : null
        }
      </div>
      <div className="advice mt-4">
        <div className="heading">Nutritional Remarks</div>
        <div className="textarea">
          <textarea
            value={dietPlanDetails?.nutritionalRemarks}
            disabled={isReadOnly}
            onChange={(e) => {
              const temp: any = { ...dietPlanDetails }
              temp["nutritionalRemarks"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            className={`${isReadOnly ? "disabled" : ""}`}
          />
        </div>
      </div>
      <div className="heading  mt-4">Dietician Incharge</div>
      <div className="referred-to-field mb-2">
        <div className="col-md-3">
          <label htmlFor="">Name</label>
          <InputField
            placeholder="Name"
            handleChange={(e: any) => {
              const temp: any = { ...dietPlanDetails }
              temp["dieticianName"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            value={dietPlanDetails?.dieticianName}
            readOnly={isReadOnly}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="">Date/Time</label>
          <InputField
            placeholder="Date/Time"
            handleChange={(e: any) => {
              const temp: any = { ...dietPlanDetails }
              temp["dateTime"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            value={dietPlanDetails?.dateTime}
            readOnly={isReadOnly}
            type="datetime-local"
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="">Emp. no</label>
          <InputField
            placeholder="Emp No"
            handleChange={(e: any) => {
              const temp: any = { ...dietPlanDetails }
              temp["dieticianEmpNo"] = e?.target?.value
              setDietPlanDetails(temp)
            }}
            value={dietPlanDetails?.dieticianEmpNo}
            readOnly={isReadOnly}
          />
        </div>
      </div>
      <div>
        <SurveyComponent
          css={""}
          data={signatureData}
          json={signatureJson}
          onComplete={(survey: any) => {
            const data = survey.data
            setSignatureData(data)
            // handleSurveyCompletion()
          }}
          updateFlag={updateSurveyData}
          hideDot={true}
        />
      </div>
      <div className="print-btn">
        <Button size="lg" disabled={isReadOnly} onClick={() => handleNutritionistDietCompletion()}>Save</Button>
      </div>
      <div className="diet-plan-print">
        <DietPlanPrint
          dietPlanDetails={dietPlanDetails}
          componentRef={componentRef}
          signatureJson={signatureJson}
          signatureData={signatureData}
          patientDetail={patientInfo}
          vitalsData={vitalsData}
          smartSummaryData={smartSummaryData}
          appointmentDate={appointmentDetails?.scheduleDate}
        />
      </div>
    </div >
  )
}
